import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:!bg-white group-[.toaster]:!text-gray-900 group-[.toaster]:!border-gray-200 group-[.toaster]:shadow-xl",
          description: "group-[.toast]:!text-gray-600",
          actionButton:
            "group-[.toast]:!bg-primary group-[.toast]:!text-primary-foreground",
          cancelButton:
            "group-[.toast]:!bg-gray-100 group-[.toast]:!text-gray-600",
          success:
            "group-[.toaster]:!bg-white group-[.toaster]:!text-gray-900 group-[.toaster]:!border-green-200",
          error:
            "group-[.toaster]:!bg-white group-[.toaster]:!text-gray-900 group-[.toaster]:!border-red-200",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
